import { Center, Stack, Text } from "@mantine/core";

import PageWrapper from "../../components/Page/PageWrapper";
import PageTitle from "../../components/Page/PageTitle";
import { QueryBuilder } from "../../components/QueryBuilder";
import Loader from "../../components/loader/loader";

import { useAdvancedSearch } from "./useAdvancedSearch.logic";
import SearchHeader from "./components/SearchHeader";
import FilterResultsTable from "./components/FilterResultsTable/FilterResultsTable";
import { useTranslation } from "react-i18next";

/**
 * Live Advanced Search page. No :id in the URL — useAdvancedSearch
 * mints a new ADVANCED_SEARCH-typed rule on mount and routes its id
 * into the rest of the page via the advancedSearchSlice.
 */
export default function AdvancedSearchPage() {
  const { ruleId, isCreating, createError } = useAdvancedSearch();
  const { t } = useTranslation();

  if (createError) {
    return (
      <PageWrapper>
        <PageTitle title={t("pageHeaders.advancedSearch")} />
        <Center mih="40vh">
          <Text c="red">
            Failed to start a new search. Try refreshing the page.
          </Text>
        </Center>
      </PageWrapper>
    );
  }

  if (isCreating || !ruleId) {
    return (
      <PageWrapper>
        <PageTitle title={t("pageHeaders.advancedSearch")} />
        <Loader height="40vh" />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.advancedSearch")} />
      <Stack gap="lg">
        <SearchHeader ruleId={ruleId} />
        <QueryBuilder ruleId={ruleId} />
        <FilterResultsTable ruleId={ruleId} />
      </Stack>
    </PageWrapper>
  );
}
